import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import { camelCase } from "lodash";

export default {
    name    : "delete-card",
    data() {
        return {
            isLoading   : true,
            isMinimal   : false,
            isFull      : false,
            cardsList   : [],
            tariffsList : [],
            payload     : {
                dateFrom    : "",
                dateTo      : ""
            },
        }
    },
    computed: {
        ...mapGetters({
            user                : 'user/user',
            deletedCard         : "userPayments/deletedCard",
            userTariff          : `user/userTariff`,
            userTariffLoading   : `user/userTariffLoading`,
            //cardsList           : "userPayments/cardsList",
            //isCardsListLoading  : "userPayments/isCardsListLoading",
        }),
    },
    created() {
        this.isMinimal  = false;
        this.isFull     = false;
        this.isLoading  = true;
        
        if(true){
			this.isMinimal  = true;
            this.isLoading  = false;
            
            return;
		}
        
        if(this.user.isNotRequiredCards === true){
            console.log('isNotRequiredCards2');
            
            this.isMinimal  = true;
            this.isLoading  = false;
            
            return;
        }
        
        this.fetchCardsList(async (items) => {
            if(items.length > 1 || items.length < 1){
                this.isMinimal  = true;
                this.isLoading  = false;
                
                return false;
            }
            
            await this.fetchUserTariff(this.payload);
            
            if(this.userTariff && this.userTariff.length){
                for(let i = 0; i < this.userTariff.length; i++){
                    let item = this.userTariff[i];
                    
                    if(item.type == "main" && item.isConnected){
                        this.tariffsList.push(item);
                    }
                }
            }
            
            if(this.tariffsList.length > 0){
                this.isMinimal  = false;
                this.isFull     = true;
                this.isLoading  = false;
            }else{
                this.isMinimal  = true;
                this.isLoading  = false;
            }
        });
    },
    methods : {
        ...mapActions({
            deleteCard      : "userPayments/DELETE_CARD",
            fetchCardsList  : "userPayments/GET_CARDS_LIST",
            fetchUserTariff : "user/GET_USER_TARIFF",
        }),
        ...mapMutations({
            changeShowPopup : "userPayments/CHANGE_POPUP_DELETE_CARD"
        }),
        async deleteCurrentCard(item) {
            this.isLoading  = true;
            
            try {
                await this.deleteCard(item).then((result) => {
                    this.$toasted.success(this.$t("successDeleteCard"));
                    
                    this.isLoading = false;
                    
                    //console.log('result:');
                    //console.log(result);
                    
                    this.changeShowPopup([false, {}]);
                    
                    this.fetchCardsList();
                });
                
                //this.changeShowPopup([false, item]);
            } catch (error) {
                this.$toasted.error(error.response.data.message);
                
                this.isLoading = false;
                
                //console.log('error:');
                //console.log(error);
            }
        },
        calculateExpiredDate(item) {
            const { activeTo } = item;
            
            if (!activeTo) {
                return "∞";
            }
            
            if(item.type == "free"){
                return "04.12.2023";
            }
            
            return moment(activeTo).format("DD.MM.YYYY");
        },
        getItemDate(item) {
            let arr = item.createdAt.split(" ");
            return moment(arr[0]).format("DD.MM.YY");
        },
        getItemTime(item) {
            let arr = item.createdAt.split(" ");
            return arr[1].slice(0, 5);
        },
        toCamelCase(str) {
            return camelCase(str);
        },
    },
};
